import { render, staticRenderFns } from "./DownloadIndex.vue?vue&type=template&id=720a2cfd&scoped=true&"
import script from "./DownloadIndex.vue?vue&type=script&lang=js&"
export * from "./DownloadIndex.vue?vue&type=script&lang=js&"
import style0 from "./DownloadIndex.vue?vue&type=style&index=0&id=720a2cfd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a2cfd",
  null
  
)

export default component.exports